import { useUserWeb3 } from '@moverfinance/web3';

const useAuthenticated = (): boolean => {
  const { active } = useUserWeb3();

  return active;
};

export default useAuthenticated;
